import React, { useContext, useEffect, useRef, useState } from "react";
import { Layout } from "antd";
import { RouteComponentProps } from "react-router";
import ProfileCard from "@Components/user/ProfileCard";
import Sidebar from "../activity/Sidebar";
import { Header } from "../shared/Header";
import { MainContext } from "@Context/provider";
import { ViewMode } from "@Context/state";
import "@Styles/main.scss";
import AutomationActions from "@Components/shared/AutomationActions";
import UserService from "@Services/UserService";
import SessionManager from "@Core/session";
import { IUserDetails } from "@Models/IUserDetails";
import { calculateFormCompletion } from "@Utils";

type IProps = RouteComponentProps & { children: any };

const ProfileLayout: React.FC<IProps> = (props: IProps) => {
    const { Content } = Layout;
    const { ui: uiState } = useContext(MainContext);
    const content = useRef<HTMLDivElement>(null);
    const [userData, setUserData] = useState<IUserDetails | null>(null);

    // Fetch user data for the fallback progress calculation
    useEffect(() => {
        const fetchUserData = async () => {
            const service = new UserService();
            const user = await service.getPrivate([SessionManager.getServiceUser()?.userId]);
            if (!user.hasErrors && user.value.length > 0) {
                setUserData(user.value[0]);
            }
        };

        fetchUserData();
    }, []);

    const profileProgress = calculateFormCompletion(userData);

    return (
        <div id="main-layout">
            <Layout style={{ height: "100%" }}>
                <Header />
                <Layout
                    id="profile-site-layout"
                    className="site-layout"
                    style={{
                        display: "flex",
                        flexDirection: "row",
                        justifyContent: "space-between",
                    }}
                >
                    {/* TODO: should only be shown to users that have permissions for demo mode */}
                    <AutomationActions />
                    <Sidebar />
                    <div
                        suppressHydrationWarning={true}
                        id="content-wrapper"
                        ref={content}
                        className="scrolling-content-wrapper profile"
                    >
                        <Content
                            id="main-layout-content"
                            className="main-layout-content"
                            style={uiState.mode === ViewMode.mobile ? { padding: 0 } : null}
                        >
                            {props.children}
                        </Content>
                    </div>
                    {uiState.mode !== ViewMode.mobile ? (
                        <div
                            id="floating-content-left-profile"
                            className="floating-content-left floating-content profile"
                            style={{
                                transition: "all 0.2s",
                            }}
                        >
                            <div className="floating-content-left-inner">
                                <ProfileCard profileProgress={profileProgress} />
                            </div>
                        </div>
                    ) : null}
                </Layout>
            </Layout>
        </div>
    );
};

export default ProfileLayout;
